export const mutations = {
  /**
   * Mutation to set dashboard in state
   */
  setDashboard(state, dashboard) {
    state.dashboard = dashboard;
  },
  /**
   * Mutation to set widgets
   */
  setWidgets(state, widgets) {
    state.widgetsByUUID = widgets;
  },
  /**
   * Mutation to add widget in grid layout
   */
  addWidget(state, { widget, ...positionDetails }) {
    state.isLayoutChanged = true;
    let widgetUUID = new Date().getTime().toString();
    state.dashboard.LayoutV2.push({
      ...positionDetails,
      i: widgetUUID,
      type: widget.type
    });
    state.widgetsByUUID[widgetUUID] = { ...widget, UUID: widgetUUID };
  },
  /**
   * Mutation to delete widget from layout available in state
   */
  deleteWidget(state, item) {
    state.isLayoutChanged = true;
    state.dashboard.LayoutV2.splice(
      state.dashboard.LayoutV2.findIndex((widget) => widget.i === item.UUID),
      1
    );
    delete state.widgetsByUUID[item.UUID];
    // push only stored widgets for removal
    if (isNaN(item.UUID)) {
      state.deletedWidgets.push(item.UUID);
    }
  },
  /**
   * Mutation to set layout
   */
  setLayout(state, layout) {
    state.dashboard.LayoutV2 = layout;
    state.isLayoutChanged = true;
  },
  /**
   * Mutation to set isWidgetMenuOpen state for widget menu drawer
   */
  setWidgetMenuState(state, isOpen) {
    state.isWidgetMenuOpen = isOpen;
  },
  /**
   * Mutation to update widget UUID in LayoutV2
   */
  updateWidgetUuid(state, { oldUuid, newUuid, IsConfigured = false }) {
    let widgetToUpdate = state.dashboard.LayoutV2.find((widget) => widget.i === oldUuid);
    widgetToUpdate.i = newUuid;
    state.widgetsByUUID[newUuid] = {
      i: newUuid,
      type: widgetToUpdate.type,
      IsConfigured
    };
    delete state.widgetsByUUID[oldUuid];
    state.isLayoutChanged = true;
  },
  /**
   * Mutation to set deleted widgets
   */
  setDeletedWidgets(state, widgets = []) {
    state.deletedWidgets = widgets;
  },

  /**
   * Mutation to set isLayoutChanged
   */
  setIsLayoutChanged(state, isLayoutChanged) {
    state.isLayoutChanged = isLayoutChanged;
  },

  /**
   * Mutation to update visibility of widget
   */
  changeWidgetVisibility(state, item) {
    state.isLayoutChanged = true;
    let index = state.dashboard.LayoutV2.findIndex((widget) => widget.i === item.UUID);
    state.dashboard.LayoutV2[index] = { ...state.dashboard.LayoutV2[index], hidden: item.hidden };
  }
};
